import { Immutable } from "immer";
import React from "react";

import { IHolidayHoursLine } from "../models";

type IProps = Immutable<{
    lines: IHolidayHoursLine[];
    className: string;
}>;

export const HolidayHoursSummary = (
    props: IProps,
): React.JSX.Element | null => {
    if (props.lines.length === 0) {
        return null;
    }
    return (
        <ul className={props.className} aria-label="Holiday hours">
            {props.lines.map((line) => (
                <li key={line.label}>
                    {line.label}: {line.schedule}
                </li>
            ))}
        </ul>
    );
};
